import { render, staticRenderFns } from "./LeadsListingTableCount.vue?vue&type=template&id=90fc45c6"
import script from "./LeadsListingTableCount.vue?vue&type=script&lang=js"
export * from "./LeadsListingTableCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports